import { motion } from "framer-motion";
import { CheckCircle } from "@phosphor-icons/react";

export default function AboutSection({ t }) {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ background: "#0A0F1A" }}
    >
      {/* Subtle bg glow */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-[#0055FF]/5 blur-[150px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Text */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm uppercase tracking-[0.2em] text-[#00F0FF] font-semibold mb-4 block font-chivo">
              {t.about.overline}
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl tracking-tight font-bold text-white font-outfit mb-6">
              {t.about.title}
            </h2>
            <p className="text-[#94A3B8] text-base leading-relaxed font-chivo mb-8">
              {t.about.description}
            </p>
            <div className="flex flex-col gap-4">
              {t.about.points.map((point, i) => (
                <div key={i} className="flex items-center gap-3" data-testid={`about-point-${i}`}>
                  <CheckCircle size={24} weight="duotone" className="text-[#00F0FF] flex-shrink-0" />
                  <span className="text-white font-chivo font-medium">{point}</span>
                </div>
              ))}
            </div>
          </motion.div>

          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="relative"
          >
            <div className="rounded-2xl overflow-hidden border border-white/10">
              <img
                src="https://images.unsplash.com/photo-1680992044138-ce4864c2b962?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxzZXJ2ZXIlMjByb29tJTIwZGF0YWNlbnRlciUyMGRhcmt8ZW58MHx8fHwxNzc2MTE1MjA2fDA&ixlib=rb-4.1.0&q=85"
                alt="Server room"
                className="w-full h-auto object-cover aspect-[4/3]"
                loading="lazy"
              />
            </div>
            {/* Floating accent */}
            <div className="absolute -bottom-4 -left-4 w-24 h-24 rounded-2xl bg-[#0055FF]/20 border border-[#0055FF]/30 backdrop-blur-sm" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
